@use '../../resources/styles/tokens' as *;
@import '../../resources/styles/typography.module.scss';
@import '../../resources/styles/common-mag.scss';
@import '../../resources/styles/a11y-mag.scss';

.linkContainer {
  @include focus-visible;
  display: inline-flex;
  align-items: center;

  @include removeButtonStyles();

  svg + span {
    margin-left: $spacing-1x;
  }

  &[href] {
    text-decoration: none;
  }

  &.withLeftMargin {
    margin-left: 1em;
  }

  &:disabled {
    cursor: default;
  }

  svg:last-child {
    margin-left: $spacing-1x;
  }

  &:focus-visible {
    border-radius: 4px;
  }
}

.innerHtmlWrapper {
  @include removeButtonStyles();

  color: $colour-link-default;
  font-weight: 600;
  font-size: 14px;

  > span > u {
    text-decoration-color: $colour-grey-300;
    text-decoration-thickness: 2px;
  }
}

.link {
  font-weight: 600;
}

.linkContainer:hover .link:not(.disabled) {
  text-decoration: underline;
}

.linkImg {
  flex-grow: 0;
  height: 24px;
  position: relative;
  padding-right: 10px;
  align-self: center;
  transform: translateY(-0.5px);

  #{$rtl} {
    padding-right: 0;
    padding-left: 3px;
  }
}

.primary {
  color: $colour-link-default;
}

.red {
  color: $colour-error-primary;
}

.white {
  color: $colour-white;
}

.black {
  color: $colour-text-primary;
}

.green {
  color: $colour-green-700;
}

.blue {
  color: $colour-blue-700;
}

.purple500 {
  color: $colour-purple-500;
}

.purple300 {
  color: $colour-purple-300;
}

.textPrimary {
  color: $colour-text-primary;
}

.disabled:not(.keepEnabledTextColour),
.linkContainer [disabled] svg > path {
  opacity: 0.65;
  cursor: default;
  color: $colour-grey-300;
}

.linkContainer [disabled] svg > path {
  fill: $colour-grey-300 !important; // !important to trump all other colours
}

.ant,
.mini-img {
  @include heading('ant');
}

.snail,
.micro-img {
  @include heading('snail');
}

.hamster,
.tinier-img {
  @include heading('hamster');
}

.cat,
.tiny-img {
  @include heading('cat');
}

.small-img {
  @include heading('sheep');
}

.medium-img {
  height: 28px;
}

.default-img {
  height: 24px;
}

.span-wrapper {
  display: flex;
  align-items: center;
}

// needed to enable tool tips while disabled
// https://github.com/ReactTooltip/react-tooltip/issues/304
.disabled-span-wrapper {
  width: 100%;
  height: 100%;
}
